import { defineFactory } from '@genesislcap/foundation-ui';
import { Login } from './main';
import { definition } from './main.definition';
/**
 * Re-define the login micro frontend.
 *
 * @example
 * ```ts
 * import { define, styles, template, defaultTemplateOptions } from '@genesislcap/foundation-login';
 * const customTemplateOptions = {
 *   ...defaultTemplateOptions,
 *   ...customOptions,
 * }
 * export const AppLogin = define({
 *   name: `nexus-login`,
 *   template: template(customTemplateOptions),
 *   styles: css`
 *     ${styles(customTemplateOptions)}
 *     some-element {
 *       background-color: #ff00b4;
 *     }
 *  `,
 * });
 * ```
 *
 * @beta
 * @privateRemarks
 * TODO: Use LoginHosted instead of Login when elements manifest stuff lands, which will drive tagFor etc.
 */
export const define = defineFactory(Login, definition);
